import CloakFetcher from 'cloak-auth/src/Client/CloakFetcher';
import { useAuthStore } from 'cloak-auth/src/Client/stores';
import useSWR from 'swr';

import { User } from '../Types/AuthServer';

export function useGetUser() {
    const subject = useAuthStore((state) => state.subject);
    const { data, isLoading, mutate } = useSWR<User>(subject && ['users/timetableprofile/', subject], CloakFetcher);

    return { isLoading, mutate, user: data! };
}
